import { colors } from '@prisjakt/ui-base';

const colorMap = (color?: string) => {
  const c = {
    Dark: colors.darkBlue1,
    Light: colors.white,
    White: colors.white,
    'Light grey': colors.semiWhite,
    'Primary blue': colors.lightBlue3,
    'Dark blue': colors.darkBlue1,
  };

  function backgroundColor() {
    if (!color) return 'inherit';
    if (['Dark', 'Light'].includes(color)) return 'inherit';

    return c[color];
  }

  function textColor() {
    if (color && ['Dark', 'Light'].includes(color)) return c[color];
    if (color && ['Primary blue', 'Dark blue'].includes(color))
      return colors.white;

    return 'inherit';
  }

  function linkColor() {
    if (color && ['Primary blue', 'Dark blue'].includes(color))
      return colors.lightBlue4;

    return colors.lightBlue3;
  }

  return {
    bg: backgroundColor(),
    text: textColor(),
    link: linkColor(),
  };
};

export default colorMap;
